// @ts-expect-error dts не существуют
import InfiniteScroll from 'vue-infinite-scroll';
// @ts-expect-error dts не существуют
import VInfiniteScroll from 'v-infinite-scroll';
// @ts-expect-error dts не существуют
import VueProgressBar from '@aacassandra/vue3-progressbar';
// @ts-expect-error dts не существуют
import Clipboard from 'v-clipboard';

// import Vuelidate from 'vuelidate';
import VueCookies from 'vue-cookies';
import Notifications from '@kyvg/vue3-notification';
import VueMarkdownEditor from '@kangc/v-md-editor';
// @ts-expect-error dts не существуют
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress';
import Storage, { type LocalStorageOptions } from '@/setup/vueLs';
import _ from '@/setup/lodash';
import { ElementSetup } from '@/setup/element';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';

// import Prism from 'prismjs';
// // highlight code
// import 'prismjs/components/prism-json';

import {
  storagePrefix,
  ignoreLocalStorageItem,
} from '@/service/configLocalStorage';
//@ts-expect-error убрали в рефакторинге тем
import { config } from '../config';
import type { App } from 'vue';

import '@/assets/styles/element-theme.scss';

/* Удаляем все ключи со старым префиксами */
const lsDeleteOldPrefix = function lsDeleteOldPrefix() {
  // eslint-disable-next-line
  for (const key in window.localStorage) {
    if (
      localStorage.hasOwnProperty(key)
      && !key.startsWith(storagePrefix)
      && !ignoreLocalStorageItem.includes(key)
    ) {
      localStorage.removeItem(key);
    }
  }
};

export default (App: App<Element>) => {
  const progressBarConfig = {
    color: config.activeColor,
    failedColor: config.dangerColor,
    thickness: '4px',
    autoRevert: true,
    inverse: false,
    transition: {
      speed: '0.2s',
      opacity: '0.6s',
      termination: 600,
    },
  };

  const storageOptions: LocalStorageOptions = {
    namespace: storagePrefix,
    name: 'ls',
    storage: 'local',
  };

  lsDeleteOldPrefix();
  App.use(VueCookies);
  App.use(InfiniteScroll);
  App.use(VInfiniteScroll);
  App.use(Clipboard);
  App.use(VueProgressBar, progressBarConfig);
  App.use(Notifications);
  App.use(Storage, storageOptions);
  App.use(ElementSetup);
  App.use(VueMarkdownEditor);
  VueMarkdownEditor.use(vuepressTheme, {
    // Prism,
  });
  // VueMarkdownEditor.lang.use('en-US', enUS);
  // VueMarkdownEditor.lang.use('ru-RU', ruRU);
};
